module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT_ExtraBold.6ea347cd.svg";